module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAOCAYAAADJ7fe0AAAAWUlEQVQokWNgoAOYycDA8B8NYwAmAoYoofHvkeuad1AXzMSlgBiXCBJyBSneOUuuIcZIbIpd8p4SQ2AuwekVuhiCHB7vCViGFaQxYKZUF1JdIohFDK+XKAYAF4wV1LkNESsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/report/design/assets/02c.png
// module id = A27o
// module chunks = 65